import Flickity from 'flickity-imagesloaded'

export default () => {
  (function() {
    const defaultSlider = document.querySelector('.default-slider')
    if (!defaultSlider) {
      return
    }
    const slides = defaultSlider.querySelectorAll('.product')
    if (defaultSlider && slides.length > 1) {
      new Flickity(defaultSlider, {
        setGallerySize: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        autoPlay: 10000,
        imagesLoaded: true,
        cellAlign: 'left'
      })
    } else {
      defaultSlider.classList.remove('flickity')
    }
  })()
  ;(function() {
    const homeBanner = document.querySelector('.brand-slider')
    if (!homeBanner) {
      return
    }
    const slides = homeBanner.querySelectorAll('.slide')
    if (homeBanner && slides.length > 1) {
      new Flickity(homeBanner, {
        setGallerySize: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        autoPlay: 10000,
        imagesLoaded: true
      })
    } else {
      homeBanner.classList.remove('flickity')
    }
  })()
  ;(function() {
    const galleryBanner = document.querySelector('.gallery')
    if (!galleryBanner) {
      return
    }
    const slides = galleryBanner.querySelectorAll('img')
    if (galleryBanner && slides.length > 1) {
      new Flickity(galleryBanner, {
        setGallerySize: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        autoPlay: 10000,
        imagesLoaded: true,
        cellAlign: 'left'
      })
    } else {
      galleryBanner.classList.remove('flickity')
    }
  })()
  ;(function() {
    const testimonial = document.querySelector('.testimonial-slider')
    if (!testimonial) {
      return
    }
    const slides = testimonial.querySelectorAll('.slide')
    if (testimonial && slides.length > 1) {
      new Flickity(testimonial, {
        setGallerySize: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true,
        autoPlay: 10000
      })
    } else {
      testimonial.classList.remove('flickity')
    }
  })()
  ;(function() {
    const fullwidthGallery = document.querySelector('.full-width-gallery')
    if (!fullwidthGallery) {
      return
    }
    const slides = fullwidthGallery.querySelectorAll('.slide')
    if (fullwidthGallery && slides.length > 1) {
      new Flickity(fullwidthGallery, {
        setGallerySize: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        autoPlay: 10000,
        imagesLoaded: true
      })
    } else {
      fullwidthGallery.classList.remove('flickity')
    }
  })()
}



// WEBPACK FOOTER //
// ./src/js/components/_flickity-sliders.js